import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null
  },
  mutations: {
    set_user (state, user) {
      state.user = user
      sessionStorage.user = user
    },
    del_user (state) {
      state.user = null
      sessionStorage.removeItem('user')
    }
  },
  actions: {
  },
  modules: {
  }
})
